<template>
    <b-form-group
            class="title">
                    <span class="span-title">
                       {{ label +' '+ $t('common.max_photo_size')}}
                    </span>
        <span v-if="hint" class="col-12 note p-1">{{ hint}}</span>
        <b-form-file
                ref="file-input"
                :value="value"
                :disabled="disabled"
                :required="required"
                v-on:input="updateValue($event)"
                accept="image/jpeg, image/jpg, image/png"
                :placeholder="$t('common.select_file')"
        />
        <span v-if="invalidPhoto"
              class="subtitle"
              style="color: red">
              {{  $t('common.image_too_big')}}
         </span>
    </b-form-group>
</template>

<script>

    export default {
        name: 'fair-image-picker',
        props: {
            label: {
                type: String,
                required: true
            },
            value: {
                type: File,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            hint: {
                type: String,
                required: false,
                default: null
            },
            required: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                invalidPhoto: false
            }
        },
        methods: {
            updateValue: function (value) {
                if(value == null) {
                    this.invalidPhoto = true
                }
                if (value !== null) {
                    let maxFileSize = 2 * 1024 * 1024 // 2 MB
                    this.invalidPhoto = value.size > maxFileSize
                    if (this.invalidPhoto) {
                        value = null
                        this.$refs['file-input'].reset()
                    }
                }
                this.$emit('input', value)
            }
        }
    }
</script>
